import React, { useEffect } from 'react';

const Faq = props => {
  useEffect(() => {
    document.body.classList.add('white');

    return function cleanup(){
      document.body.classList.remove('white');
    }
  }, []);

  return <div className='shop-page transition'>
    <div className="content">
      <div className="inner">
        <h4>What payment methods do you accept?</h4>
        <p>We accept Visa, Mastercard, Amex, PayPal. Payment must be successfully completed before we can process your order.</p>

        <h4>I didn’t get a confirmation email. What do I do?</h4>
        <p>Email us at <a href="mailto:shop@akkurat.tv">shop@akkurat.tv</a> It’s possible your payment was not successfully processed, one of the items in your cart is out of stock, or there was an issue with your email address.</p>

        <h4>What do I do if something I like is out of stock?</h4>
        <p>We only sell limited editions.</p>

        <h4>What is the status of my order?</h4>
        <p>Check the status of your order via the tracking link provided in your shipping email.</p>

        <h4>What do I do if I have another question or issue?</h4>
        <p>Email us at <a href="mailto:shop@akkurat.tv">shop@akkurat.tv</a> Please include your order number in the subject line if you have one.</p>

        <h4>Where do you ship?</h4>
        <p>We currently ship to Australia, Brazil, Canada, the EU, Indonesia, Japan, Malaysia, Mexico, New Zealand, Norway, Singapore, South Korea, Switzerland, Taiwan, UK, and US. Additional customs and import taxes or fees may apply to international orders. These fees are calculated and due at checkout. Don't see your country? Tell us where you're from at <a href="mailto:shop@akkurat.tv">shop@akkurat.tv</a> <br /><br />
        COVID-19 UPDATE: Shipment to  Argentina, Chile, India, Philippines, Spain, and UAE has been temporarily suspended.
        </p>

        <h4>When will my order ship?</h4>
        <p>We typically process orders within seven business days. Please check our product pages as some products have longer ship times or are pre-orders.</p>

        <h4>How much does shipping cost?</h4>
        <p>Shipping varies by country and is calculated at checkout</p>

        <h4>I messed up my address! Can I fix it?</h4>
        <p>Email us as soon as possible at <a href="mailto:shop@akkurat.tv">shop@akkurat.tv</a> with your order number and the correct address. We can update your address as long as your order hasn’t already shipped. Unfortunately, once your order has shipped, we are unable to make changes.</p>

        <h4>My order says it’s been delivered but I haven’t received anything. What should I do?</h4>
        <p>AKKURAT is not responsible for items that are lost or stolen, but email us at <a href="mailto:shop@akkurat.tv">shop@akkurat.tv</a> and we will try to help figure it out. Please include your order number in the subject line.</p>

        <h4>Can I change or cancel my order?</h4>
        <p>We can cancel your order as long as it hasn’t already shipped. If you would like to make a change, please email us as soon as possible at <a href="mailto:shop@akkurat.tv">shop@akkurat.tv</a> and include your order number in the subject line.</p>

        <h4>Can I exchange my order?</h4>
        <p>Exchanges can be made within 30 days of placing your order. Please understand that our items are limited and we might not have your desired size. We cannot exchange one item for a different item. Email <a href="mailto:shop@akkurat.tv">shop@akkurat.tv</a> and include your order number and the size you would like.</p>

        <h4>Can I return my order?</h4>
        <p>We do not accept returns. If you have an issue, please email us at <a href="mailto:shop@akkurat.tv">shop@akkurat.tv</a> within 30 days of placing your order and we will try our best to find a solution. Please include your order number in the subject line.</p>

        <h4>How long does a refund take to process?</h4>
        <p>It usually takes 5 to 10 business days for a refund to be credited back to your account. We can only issue a refund to the original payment method.</p>
      </div>
    </div>
    <div className="image" style={{backgroundImage: 'url(/static/faqs.jpg)'}} />
  </div>;
}

export default Faq;
